<div class="main-page-bg">
  <div [ngStyle]="{'height.px': sideDivHeight}" class="left-sec">
    <i class="fad fa-link icon-for-left-sec"></i>

    <h4 class="sub-header">PrimeCommunication</h4>
    <h4 class="text-white app-type">Relay Accounts Management</h4>

    <h5 *ngIf="!isLoggedIn" class="details text-white">
      Enter your email and password to login.
    </h5>

    <h4 class="mms text-white-50 text-muted">
      Micro Merchant Systems, Inc.
    </h4>
  </div>

  <div [ngStyle]="{'height.px': sideDivHeight}" class="right-sec">
    <div class="right-vertical-center">
      <div *ngIf="!isLoggedIn" class="login-wrapper">
        <div>
          <h4 class="font-weight-bold">
            Login
          </h4>
          <hr />

        </div>

        <form (ngSubmit)="login()" [formGroup]="loginForm">
          <div class="form-group">
            <label class="d-block">
              <label for="emailAddress" class="input-label">* Email address</label>
              <input type="email" placeholder="hello@gmail.com" formControlName="emailAddress" />
              <label [ngClass]="isEmailEntered ? '' : 'active'" class="error">{{emailMessage}}</label>
            </label>
          </div>
          <div class="form-group">
            <label class="d-block">
              <label for="password" class="input-label">* Password</label>
              <input [type]="fieldTextType ? 'text' : 'password'" placeholder="At least 6 characters"
                formControlName="password">
              <label [ngClass]="isPasswordEntered ? '' : 'active'" class="error">{{passwordMessage}}</label>
              <span [ngClass]="isPasswordEntered ? '' : 'input-group-icon-validation-offset'"
                class="input-group-icon input-group-icon-adjusted-margin float-right">
                <i class="fas" (click)="toggleFieldTextType()"
                  [ngClass]="{ 'fa-eye-slash': !fieldTextType, 'fa-eye': fieldTextType}"></i>
              </span>
            </label>
            <a class="right-link">Forgot Password?</a>
          </div>
          <div class="form-group">
            <button type="submit" class="btn btn-success btn-login" type="submit">
              <span [hidden]="isLoading">Submit</span>
              <span [hidden]="!isLoading">
                <i class="fas fa-spinner fa-pulse"></i>
              </span>
            </button>
            <div [hidden]="!isErrorVisible" class="alert alert-danger mt-2" role="alert">
              {{ error }}
            </div>


          </div>
        </form>
      </div>

      <div *ngIf="isLoggedIn" class="login-wrapper">
        <h6 class="font-bold text-black-50">You are already logged in.</h6>
        <img class="logged-in-img" src="./assets/loggedin.png" />
        <div class="mt-3">
          <button type="button" class="btn btn-success" (click)="goToDashboard()">Go to Dashboard</button>
          <button type="button" class="ml-2 btn btn-danger" (click)="logout()">Logout</button>
        </div>
      </div>
    </div>
  </div>

</div>
